import React from 'react';
import Box from '@mui/material/Box';
import SideNavigation, { SIDENAV_WIDTH, SIDENAV_HEIGHT } from './SideNavigation';
import SongHistory from './SongHistory';
import ScrollFadeBox from './ScrollFadeBox';
import { useOnlineStatusContext } from './OnlineStatusContext';

export { SIDENAV_WIDTH };

export default function LeftSidebar({ onNavigate }) {
  const { bannerOffset } = useOnlineStatusContext();

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' },
        position: 'fixed',
        top: 64 + bannerOffset,
        left: 0,
        bottom: 66,
        width: SIDENAV_WIDTH,
        zIndex: 1100,
        transition: 'top 0.25s ease',
      }}
    >
      <SideNavigation onNavigate={onNavigate} />

      <ScrollFadeBox
        sx={{ position: 'absolute', top: SIDENAV_HEIGHT, left: 0, right: 0, bottom: 0 }}
        scrollSx={{ paddingLeft: 2, paddingRight: 1 }}
      >
        <SongHistory compact />
      </ScrollFadeBox>
    </Box>
  );
}
